const primaryDisabled = {
    '&:disabled': {
        cursor: 'default',
        backgroundColor: 'neutralBgStrongDisabled',
        color: 'baseTextWeak',
    },
};
const secondaryDisabled = {
    '&:disabled': {
        cursor: 'default',
        backgroundColor: 'neutralBg',
        borderColor: 'neutralBorderStrongDisabled',
        color: 'neutralTextStrongDisabled',
    },
};
const tertiaryDisabled = {
    '&:disabled': {
        cursor: 'default',
        backgroundColor: 'transparent',
        color: 'neutralTextWeak',
    },
};
export const iconButtons = {
    primaryIcon: Object.assign({ color: 'baseTextWeak', backgroundColor: 'baseBg', '&:hover': {
            backgroundColor: 'baseBgMedium',
        } }, primaryDisabled),
    secondaryIcon: Object.assign({ color: 'baseText', backgroundColor: 'neutralBg', border: '1px solid', borderColor: 'baseBorder', '&:hover': {
            color: 'baseTextActive',
            borderColor: 'baseBorderActive',
        } }, secondaryDisabled),
    tertiaryIcon: Object.assign({ color: 'baseText', backgroundColor: 'transparent', '&:hover': {
            color: 'baseTextActive',
            backgroundColor: 'baseBgWeakActive',
        } }, tertiaryDisabled),
    mutedIcon: Object.assign({ color: 'baseTextWeak', backgroundColor: 'neutralBgWeakInverted', '&:hover': {
            backgroundColor: 'neutralBgMediumInverted',
        } }, primaryDisabled),
    mutedTertiaryIcon: Object.assign({ color: 'neutralTextStrong', backgroundColor: 'transparent', '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)', // TODO(Sara) do we need a semantic alternative?
        } }, tertiaryDisabled),
};
export const iconButtonsSizes = {
    s: {
        height: '34px',
        width: '34px',
    },
    m: {
        height: '42px',
        width: '42px',
    },
    l: {
        height: '50px',
        width: '50px',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWNvbkJ1dHRvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvaWNvbkJ1dHRvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxlQUFlLEdBQUc7SUFDdEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFLFNBQVM7UUFDakIsZUFBZSxFQUFFLHlCQUF5QjtRQUMxQyxLQUFLLEVBQUUsY0FBYztLQUN0QjtDQUNGLENBQUM7QUFFRixNQUFNLGlCQUFpQixHQUFHO0lBQ3hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRSxTQUFTO1FBQ2pCLGVBQWUsRUFBRSxXQUFXO1FBQzVCLFdBQVcsRUFBRSw2QkFBNkI7UUFDMUMsS0FBSyxFQUFFLDJCQUEyQjtLQUNuQztDQUNGLENBQUM7QUFFRixNQUFNLGdCQUFnQixHQUFHO0lBQ3ZCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRSxTQUFTO1FBQ2pCLGVBQWUsRUFBRSxhQUFhO1FBQzlCLEtBQUssRUFBRSxpQkFBaUI7S0FDekI7Q0FDRixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUF1QjtJQUM3QyxXQUFXLGtCQUNULEtBQUssRUFBRSxjQUFjLEVBQ3JCLGVBQWUsRUFBRSxRQUFRLEVBQ3pCLFNBQVMsRUFBRTtZQUNULGVBQWUsRUFBRSxjQUFjO1NBQ2hDLElBQ0UsZUFBZSxDQUNuQjtJQUNELGFBQWEsa0JBQ1gsS0FBSyxFQUFFLFVBQVUsRUFDakIsZUFBZSxFQUFFLFdBQVcsRUFDNUIsTUFBTSxFQUFFLFdBQVcsRUFDbkIsV0FBVyxFQUFFLFlBQVksRUFDekIsU0FBUyxFQUFFO1lBQ1QsS0FBSyxFQUFFLGdCQUFnQjtZQUN2QixXQUFXLEVBQUUsa0JBQWtCO1NBQ2hDLElBQ0UsaUJBQWlCLENBQ3JCO0lBQ0QsWUFBWSxrQkFDVixLQUFLLEVBQUUsVUFBVSxFQUNqQixlQUFlLEVBQUUsYUFBYSxFQUM5QixTQUFTLEVBQUU7WUFDVCxLQUFLLEVBQUUsZ0JBQWdCO1lBQ3ZCLGVBQWUsRUFBRSxrQkFBa0I7U0FDcEMsSUFDRSxnQkFBZ0IsQ0FDcEI7SUFDRCxTQUFTLGtCQUNQLEtBQUssRUFBRSxjQUFjLEVBQ3JCLGVBQWUsRUFBRSx1QkFBdUIsRUFDeEMsU0FBUyxFQUFFO1lBQ1QsZUFBZSxFQUFFLHlCQUF5QjtTQUMzQyxJQUNFLGVBQWUsQ0FDbkI7SUFDRCxpQkFBaUIsa0JBQ2YsS0FBSyxFQUFFLG1CQUFtQixFQUMxQixlQUFlLEVBQUUsYUFBYSxFQUM5QixTQUFTLEVBQUU7WUFDVCxlQUFlLEVBQUUsb0JBQW9CLEVBQUUsZ0RBQWdEO1NBQ3hGLElBQ0UsZ0JBQWdCLENBQ3BCO0NBQ0YsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUE4QjtJQUN6RCxDQUFDLEVBQUU7UUFDRCxNQUFNLEVBQUUsTUFBTTtRQUNkLEtBQUssRUFBRSxNQUFNO0tBQ2Q7SUFDRCxDQUFDLEVBQUU7UUFDRCxNQUFNLEVBQUUsTUFBTTtRQUNkLEtBQUssRUFBRSxNQUFNO0tBQ2Q7SUFDRCxDQUFDLEVBQUU7UUFDRCxNQUFNLEVBQUUsTUFBTTtRQUNkLEtBQUssRUFBRSxNQUFNO0tBQ2Q7Q0FDRixDQUFDIn0=